export default __webpack_public_path__ + "static/saberlogo-2c9480ba5ff4ccea5fae1ef8ce4e728c.png";